import { AfterContentInit, Component, ContentChild, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { NgControl } from '@angular/forms';
import { SegoeMDL2Font } from '../../../enums/shared/segoe-mdl2-font';
import { SelectablePaneItems } from './models/selectable-pane-item';
import { ISelectablePane } from '../../../interfaces/common-interface';
import { RawCombinedSaleProduct } from '../../../../modules/common/order-entry/models/check-commodity-response';

export type TemplateType = 'horizontal' | 'vertical' | 'complex';

@Component({
    selector: 'egl-selectable-pane',
    templateUrl: './egl-selectable-pane.component.html',
    styleUrls: ['./egl-selectable-pane.component.scss'],
})
export class EglSelectablePaneComponent implements AfterContentInit {
    readonly icons = SegoeMDL2Font;
    @Input() title: string;
    @Input() subtitle: string;
    @Input() text: string;
    @Input() icon?: string;
    @Input() iconWidth?: number;
    @Input() iconHeight?: number;
    @Input() haveSubtitle: boolean;
    @Input() infoList?: ISelectablePaneInfoItem[];
    @Input() layoutColorBlue?: boolean;
    @Input() titleOnly?: boolean;
    @Input() items: SelectablePaneItems[] = [];
    @Input() templateType: TemplateType = 'vertical';
    /**
     * @deprecated utilizzare l'input
     */
    @Input() data?: SelectablePane | ISelectablePane | RawCombinedSaleProduct;
    @Input() tag: string;
    /**
     * @deprecated utilizzare il disabled sull'input
     */
    @Input() isDisabled: boolean;
    @Input() bulletListPane?: string[];
    /**
     * @deprecated utilizzare NgModel/FormControl dell'input
     */
    @Output() onSelectedItem = new EventEmitter<string>();

    @ContentChild(NgControl) private childCtrl!: NgControl;
    @ContentChild(NgControl, { read: ElementRef, static: false }) public childElement: ElementRef<HTMLInputElement>;

    ngAfterContentInit(): void {
        if (!this.data) {
            this.data = Object.defineProperties(
                {
                    id: this.childElement?.nativeElement?.attributes?.getNamedItem('name'),
                    value: this.childElement?.nativeElement?.value,
                } as unknown as SelectablePane,
                {
                    selected: {
                        get: (): boolean => this.childElement?.nativeElement?.checked,
                    },
                }
            );
        }
    }
    /**
     * @description Gestisce l'evento di selezione del "SelectablePane" eseguendo l'emit dell'id dell'oggetto data
     * @returns void
     */
    onSelected(): void {
        this.onSelectedItem.emit(this.data['id']);
    }

    isSelected(): boolean {
        return this.childElement?.nativeElement?.checked || this.data?.["selected"];
    }

    getDisabled(): boolean {
        return this.childCtrl?.disabled || this.isDisabled;
    }
}

/**
 * @deprecated utilizzare formControl, formControlName o ngModel sull'input
 */
export class SelectablePane {
    id: string;
    value: any;
    selected: boolean;
    disabled?: boolean;
}

export interface ISelectablePaneInfoItem {
    title: string;
    value: string;
}
